/**
 *  current base url e.g. http://localhost:8080, https://www.example.com or https://demo.application.com
 * @return {string}
 */
const getFrontendUrl = (): string => {
  //get origin
  return window.location.origin;
};

export const urlUtils = {
  getFrontendUrl: getFrontendUrl,
};
